import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { Plus } from '@opengov/react-capital-assets';
import { IPublication } from '@opengov/stories-shared/types';
import React from 'react';
import { ComponentErrorBoundary } from '../../ErrorBoundary/ComponentErrorBoundary';
import locale from './customReports-locale.json';
import { styles } from './CustomReports.style';
import { CustomReportsFallback } from './CustomReportsFallback';
import { CustomReportsTable } from './CustomReportsTable';
import { NewExcelFileModal } from './NewExcelFileModal/NewExcelFileModal';

type Props = {
  publication: IPublication;
};

type Modal = 'add-new-excel-file';

function CustomReports({ publication }: Props) {
  const [activeModal, setActiveModal] = React.useState<Modal | null>(null);

  return (
    <Box sx={styles.container}>
      <Box sx={styles.header}>
        <Box>
          <Typography variant="h3" gutterBottom>
            {locale.title}
          </Typography>
          <Typography variant="body2">{locale.subtitle}</Typography>
        </Box>
        <Button
          variant="outlined"
          startIcon={<Plus />}
          data-test="custom-reports-table-new-excel-file-button"
          onClick={() => setActiveModal('add-new-excel-file')}
        >
          {locale.newExcelFile}
        </Button>
      </Box>

      <CustomReportsTable publication={publication} onUploadClick={() => setActiveModal('add-new-excel-file')} />

      {activeModal === 'add-new-excel-file' ? (
        <NewExcelFileModal
          publication={publication}
          mode={{ variant: 'create' }}
          onClose={() => setActiveModal(null)}
        />
      ) : null}
    </Box>
  );
}

export function CustomReportsBoundary({ publication }: Props) {
  return (
    <ComponentErrorBoundary FallbackComponent={CustomReportsFallback}>
      <CustomReports publication={publication} />
    </ComponentErrorBoundary>
  );
}
